
import React, {useEffect, useState} from 'react';

import LoftyCarousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

import {
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';

import {getAllproductsdb } from '../../api/productsdb.api'

import './initpage.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    




const Pinitpage = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {

	const [loftyendpoint_68e5851fa5fe5912e600222d, setLoftyEndpoint_68e5851fa5fe5912e600222d] = useState([]);
	

useEffect(() => {
		const loftyHandleData = async () => {
			const loftyres_68e5851fa5fe5912e600222d = await getAllproductsdb({ token: loftytoken || 'asdsa' });
			setLoftyEndpoint_68e5851fa5fe5912e600222d(loftyres_68e5851fa5fe5912e600222d.data);
		}
		loftyHandleData();
	}, []);



  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id68e531018e5aed52dc7f00e5" >

      <div id="iw4j" className="">
      
      <div id="iwv3ah" className="">
      
      <div id="itmdc" className="">
      
      <img
        className=""
        id="ismeq"
        src="https://assetsprojects.s3.amazonaws.com/404pziimggu1zyt.png"
        alt="undefined"
      />
      
      <div className="" id="is8n8g">
        <>PETRUS GEMS</>
      </div>
      
      </div>
      
      <img
        className=""
        id="iok6z3"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgjq3ce5.jpg"
        alt="undefined"
      />
      
      <div id="i4kmai" className="">
      
        <a
          target=""
          className=""
          id="itw0wk"
          href="tel:+50488951552"
        >
          
    <div id="i3h60u" className="">
    <>+504 8895-1552</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      <div id="ips2" className="">
      
      <div id="iowj1k" className="">
      
      <div id="iwg34j" className="">
      
      <a
        target=""
        className=""
        id="il8xfg"
        href="/"
        type="button"
      >
        
    <div id="ihswfv" className="">
    <>INICIO</>
    </div>
    
      </a>
      
      <a
        target=""
        className="link "
        id="iuicrj"
        href="/productos"
        type="button"
      >
        
    <div id="ih9i7g" className="">
    <>PRODUCTOS</>
    </div>
    
      </a>
      
      <a
        target=""
        className="link "
        id="ib4wzs"
        href="/certificaciones"
        type="button"
      >
        
    <div id="ie4p6q" className="">
    <>CERTIFICACIONES</>
    </div>
    
      </a>
      
      <a
        target=""
        className="link "
        id="itj7od"
        href="/contacto"
        type="button"
      >
        
    <div id="i6b0kg" className="">
    <>CONTACTO</>
    </div>
    
      </a>
      
      </div>
      
      <div id="i0vlk5" className="">
      
        <a
          target=""
          className=""
          id="ihypi2"
          href="/carritocompras"
        >
          
      <img
        className=""
        id="i7mm4p"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgjoujuz.png"
        alt="undefined"
      />
      
        </a>
        
      </div>
      
      </div>
      
      <div id="icq3pj" className="">
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/"
        type=""
      >
        <>Inicio</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/productos"
        type=""
      >
        <>Productos</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/certificaciones"
        type=""
      >
        <>Certificaciones</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/contacto"
        type=""
      >
        <>Contacto</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      </ul>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ihk8" className="">
      
      <div id="it6xg" className="">
      
      <div
        id="i3qkq4"
        className=""
        data-aos="fade-down"
        data-aos-duration="200"
      >
      
      <div className="" id="ip3sl">
        <>PETRUS</>
      <br className="" id="" />
      <>GEMS </>
      </div>
      
      <div className="" id="i803s">
        <>gemas naturales hondureñas</>
      </div>
      
        <a
          target=""
          className=""
          id="ipixvn"
          href="/productos"
        >
          
    <div id="i4s71c" className="">
    <>COMPRAR</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      </div>
      
      <div id="i3m0i" className="">
      
      <div
        id="iz167x"
        className=""
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
      <div id="ikse2e" className="">
      
      <div
        id="ifkkdi"
        className=""
        data-aos="fade-right"
        data-aos-duration="1000"
      >
      
      <img
        className=""
        id="if5wjh"
        src="https://assetsprojects.s3.amazonaws.com/404pziimggzcbmh.png"
        alt="undefined"
      />
      
      <div id="iwonzd" className="">
      
      </div>
      
      <img
        className=""
        id="idbf4d"
        src="https://assetsprojects.s3.amazonaws.com/404pziimggzhtfn.png"
        alt="undefined"
      />
      
      </div>
      
      <div
        id="iixk9r"
        className=""
        data-aos="fade-left"
        data-aos-duration="1000"
      >
      
      <div className="" id="ii5v25">
        <>GEMAS</>
      <br className="" id="" />
      <>NATURALES</>
      <br className="" id="" />
      <>HONDUREÑAS</>
      <br className="" id="" />
      
      </div>
      
      <div className="" id="iqfsim">
        <>PETRUS GEMS es una empresa que recolecta y transforma gemas naturales Hondureñas  bajo un sistema artesanal cuidando el medio ambiente en conjunto con comunidades desarrollando con ellos comunidades sostenibles</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div
        id="idusuq"
        className=""
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
      <div id="itrgfk" className="">
      
      <div className="" id="igqyi">
        <>Elaboración de joyas de forma artesanal por mano de mujeres en nuestras comunidades</>
      <br className="" id="" />
      
      </div>
      
      <div
        id="i1ph8w"
        className=""
        data-aos="fade-up"
        data-aos-duration="1000"
      >
      
      <div id="itvsvv" className="">
      
      <div id="ibmlcj" className="">
      
      <div className="" id="iuzegw">
        <>MISIÓN</>
      </div>
      
      <div className="" id="i55l6c">
        <>Nuestra misión es proteger y restaurar el medio ambiente, mitigando los efectos del cambio climático a través de soluciones innovadoras, sostenibles y colaborativas. Nos comprometemos a educar y empoderar a las comunidades para que adopten prácticas ecológicas que aseguren un futuro saludable y sostenible para las generaciones presentes y futuras. gemas naturales hondureñas</>
      </div>
      
      </div>
      
      <div id="immprl" className="">
      
      <div className="" id="i43rru">
        <>VISIÓN</>
      </div>
      
      <div className="" id="i11m82">
        <>Nuestra visión es ser líderes globales en la transformación hacia un planeta más verde y resiliente, donde las comunidades vivan en armonía con la naturaleza. Aspiramos a un mundo donde la biodiversidad prospere, los recursos naturales se gestionen de manera sostenible y las emisiones de carbono se reduzcan significativamente, contribuyendo a un equilibrio climático global.</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i3dh" className="">
      
      <div id="ipul3d" className="">
      
      </div>
      
      <div className="" id="ity5s2">
        <>Productos Destacados</>
      </div>
      
        <div id="i6ge4s" className="">
          
            <div>
              <LoftyCarousel
                responsive={{
                  superLargeDesktop: {
                    breakpoint: {max: 4000, min: 3000},
                    items: 3,
                  },
                  desktop: {
                    breakpoint: {max: 3000, min: 1024},
                    items: 3,
                  },
                  tablet: {
                    breakpoint: {max: 1024, min: 464},
                    items: 3,
                  },
                  mobile: {
                    breakpoint: {max: 464, min: 0},
                    items: 1,
                  },
                }}
                infinite
                autoPlay
              >
                {
                  loftyendpoint_68e5851fa5fe5912e600222d.map((loftyitem) => (
                    <div key={loftyitem._id} className="" id="ig4udn">
                      
        <img
          className=""
          id="i22z1z"
          alt=""
          src={loftyitem.loftyUrl}
        />
        
        <div className="" id="izgqk6">
          
          <div className="" id="">
            {loftyitem.productname}
          </div>
          
        </div>
        
        <div className="" id="ilb7x7">
          
            <div className="" id="">
              {parseFloat(loftyitem.productprice)?.toLocaleString('en-US', {minimumFractionDigits: 2})}
            </div>
            
        </div>
        
        <div className="" id="ir21ad">
          
            <div className="" id="">
              {parseFloat(loftyitem.typeofproduct)?.toLocaleString('en-US', {minimumFractionDigits: 2})}
            </div>
            
        </div>
        
        <div className="" id="idfb6l">
          
          <div className="" id="">
            {loftyitem.loftyOriginalName}
          </div>
          
        </div>
        
        <div className="" id="iqvv5t">
          
          <div className="" id="">
            {loftyitem.loftyFileName}
          </div>
          
        </div>
        
        <div className="" id="i08j4d">
          
          <div className="" id="">
            {loftyitem.loftyUrl}
          </div>
          
        </div>
        
                    </div>
                  ))
                }
              </LoftyCarousel>
            </div>
            
        </div>
        
      <div className="" id="isqx5v">
        <>Catálogo</>
      </div>
      
      <div id="ihp5j" className="">
      
      <div
        id="idbn6k"
        className=""
        data-aos="fade-up"
        data-aos-duration="1000"
      >
      
      <div className="" id="iyi33">
        <>Anillos</>
      </div>
      
      <img
        className=""
        id="iwj249"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgi8jxsp.png"
        alt="undefined"
      />
      
      </div>
      
      <div
        id="im7mqv"
        className=""
        data-aos="fade-down"
        data-aos-duration="1000"
      >
      
      <img
        className=""
        id="idyt3z"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgi8l6el.png"
        alt="undefined"
      />
      
      <div className="" id="iit6zr">
        <>Collares</>
      </div>
      
      </div>
      
      <div
        id="ilkt02"
        className=""
        data-aos="fade-up"
        data-aos-duration="1000"
      >
      
      <div className="" id="i071f3">
        <>Aretes</>
      </div>
      
      <img
        className=""
        id="iyi7eq"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgi8nzii.png"
        alt="undefined"
      />
      
      </div>
      
      <div
        id="ibr4y3"
        className=""
        data-aos="fade-down"
        data-aos-duration="1000"
      >
      
      <img
        className=""
        id="i8abub"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgi8p4lt.png"
        alt="undefined"
      />
      
      <div className="" id="ivn7vs">
        <>Pulseras</>
      </div>
      
      </div>
      
      </div>
      
      <div id="iuqmac" className="">
      
        <a
          target=""
          className=""
          id="iysw8d"
          href="/productos"
        >
          
    <div id="iwr5ao" className="">
    <>Ver Todo</>
    </div>
    
        </a>
        
      </div>
      
      <div className="" id="iy6vw1">
        <>Certificados</>
      </div>
      
      <div
        id="i80i5e"
        className=""
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
      <div id="ibbhmj" className="">
      
      <div id="i8ctdh" className="">
      
      <div id="ijzcp9" className="">
      
      <img
        className=""
        id="id6il1"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgi8zbdz.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="ijudq6" className="">
      
        <a
          target=""
          className=""
          id="iwcecy"
          href="/certificaciones"
        >
          
    <div id="i9n4mg" className="">
    <>Ver Más</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      <div id="ix7g49" className="">
      
      <div id="i006rr" className="">
      
      <img
        className=""
        id="ice9zp"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgi92pvk.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="i5wcc1" className="">
      
      <div className="" id="isi0xr">
        <>Carlos Handal.</>
      <br className="" id="" />
      <>un empresario comprometido con </>
      <br className="" id="" />
      <>la “Honduras Verde”</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="idll5j" className="">
      
      <img
        className=""
        id="ilrm3v"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgi992rx.png"
        alt="undefined"
      />
      
      <div id="irmzsn" className="">
      
      <div id="ie12dn" className="">
      
      </div>
      
      <img
        className=""
        id="icjgzs"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgi9c71w.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="iack7t" className="">
      
      <img
        className=""
        id="i5nc11"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgi9fr4n.png"
        alt="undefined"
      />
      
      <img
        className=""
        id="iugxq8"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgi9geln.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      </div>
      
      <div id="icohi" className="">
      
      <div id="iyghfd" className="">
      
      <div id="i52pnr" className="">
      
      <div className="" id="iyo7r6">
        <>Petrus Gems</>
      </div>
      
      <div className="" id="iygu8i">
        <>Elaboración de joyas de forma artesanal por mano de mujeres en nuestras comunidades</>
      </div>
      
      <div id="ix6pbo" className="">
      
        <a
          target=""
          className=""
          id="ibwuje"
          href="https://www.facebook.com/gemspetrus.hn"
        >
          
      <img
        className=""
        id="iy1qpk"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgiadxwc.png"
        alt="undefined"
      />
      
        </a>
        
        <a
          target=""
          className=""
          id="iqvgxw"
          href="https://www.instagram.com/gemspetrus/"
        >
          
      <img
        className=""
        id="i26xh9"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgiafdkq.png"
        alt="undefined"
      />
      
        </a>
        
      </div>
      
      </div>
      
      <div id="id3akf" className="">
      
      <div className="" id="i160fk">
        <>Enlaces Rápidos</>
      </div>
      
      <div id="iacot" className="">
      
      <a
        target=""
        className=""
        id="i2hsg"
        href="/"
        type="button"
      >
        
    <div id="ij3vk" className="">
    <>Inicio</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="i2aqf"
        href="/productos"
        type="button"
      >
        
    <div id="i2g1w" className="">
    <>Productos</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="i31ek"
        href="/certificaciones"
        type="button"
      >
        
    <div id="ipu5h" className="">
    <>Certificados</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="ixxmu"
        href="/contacto"
        type="button"
      >
        
    <div id="ikc1x" className="">
    <>Contacto</>
    </div>
    
      </a>
      
      </div>
      
      </div>
      
      <div id="ipuzkj" className="">
      
      <div className="" id="ifh7p5">
        <>Contacto</>
      </div>
      
      <div id="iincid" className="">
      
      <span className="material-icons " id="iwlmju">
        
      <span className="material-icons " id="iz5z0g">
        <>call</>
      </span>
      
      </span>
      
      <div className="" id="i78qcc">
        <>+504 8895-1552</>
      </div>
      
      </div>
      
      <div id="idmnrv" className="">
      
      <span className="material-icons " id="i7tn5m">
        
      <span className="material-icons " id="isg8ci">
        
      <span className="material-icons " id="iuenok">
        <>mail</>
      </span>
      
      </span>
      
      </span>
      
      <div className="" id="il1rnw">
        <>handalcarl13@gmail.com</>
      </div>
      
      </div>
      
      <div id="i2jt24" className="">
      
      <span className="material-icons " id="il9zag">
        
      <span className="material-icons " id="iom84k">
        
      <span className="material-icons " id="i1y0v4">
        
      <span className="material-icons " id="iwl57t">
        <>my_location</>
      </span>
      
      </span>
      
      </span>
      
      </span>
      
      <div className="" id="i1at63">
        <>ubicacion</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pinitpage);
  